const defaultValuesAudBuild = [
  { name: "Household Demographics", status: false },
  { name: "Household Income, Wealth Assets & Home Value", status: false },
  { name: "Credit Repair Interest & Credit Report Interest", status: false },
  { name: "Education Level", status: false },
  { name: "Occupation", status: false },
  { name: "Gender, Age & Speaks Spanish", status: false },
  { name: "Purchase Likelihood", status: false },
  { name: "Brand Loyalty", status: false },
  { name: "Vehicle Purchase Date", status: false },
  { name: "Vehicle Fuel", status: false },
  { name: "Vehicle Class", status: false },
  { name: "Vehicle Mileage", status: false },
  { name: "Vehicle Year", status: false },
  { name: "Vehicle Models", status: false },
  { name: "Vehicle Makes", status: false },
  { name: "Zip Code Radius", status: false },
  { name: "Map", status: false },
  { name: "Recall", status: false },
  { name: "Interests", status: false },
]

export default defaultValuesAudBuild
